<template>
  <div>
    <div class="row col-12 text-brand-5 text-weight-bold q-gutter-sm q-mb-md">
      <div class="col-md-1 col-xs-4">
        <div class="q-ml-sm titulo-input">Unidade</div>
        <q-input
          dense
          disable
          outlined
          class="bg-brand-7 input"
          v-model="unidade.nome"
        />
      </div>
      <div class="col-md-2 col-xs-4">
        <div class="q-ml-sm titulo-input">Área de Trabalho</div>
        <q-input
          dense
          outlined
          class="input"
          v-model="novaInformacao.areaTrabalho"
          type="text"
        />
      </div>
      <div class="col-md-1 col-xs-3">
        <div class="q-ml-sm titulo-input">Observação</div>
        <q-input
          dense
          outlined
          class="input"
          v-model="novaInformacao.observacao"
          type="text"
        />
      </div>
      <div class="col-md-2 col-xs-4">
        <div class="q-ml-sm titulo-input">Outras Medidas</div>
        <q-input
          dense
          outlined
          class="input"
          v-model="novaInformacao.outrasMedidas"
          type="text"
        />
      </div>
      <div class="col-md-1 col-xs-4">
        <div class="q-ml-sm titulo-input">Aviso</div>
        <q-input
          dense
          outlined
          class="input"
          v-model="novaInformacao.aviso"
          type="text"
        />
      </div>
      <div class="col-md-2 col-xs-3">
        <div class="q-ml-sm titulo-input">Recomendação</div>
        <q-input
          dense
          outlined
          class="input"
          v-model="novaInformacao.recomendacao"
          type="text"
        />
      </div>
      <div class="col-lg-2 col-md-3">
        <p></p>
        <q-btn
          dense
          label="Adicionar Informações"
          color="positive"
          icon="add_circle_outline"
          class="q-mt-sm btn-enviar"
          no-caps
          @click="adicionarInformacao()"
        />
      </div>
    </div>

    <div v-if="informacoes.length > 0" class="q-mt-lg">
      <span
        class="row col-12 text-brand-5 text-weight-bold q-ml-md q-mb-md titulo-table"
      >
        Lista de Informações
      </span>
      <q-table
        flat
        table-header-class="bg-accent text-weight-bold"
        :rows="informacoes"
        :columns="columns"
        row-key="id"
        class="tabela-tamanho-fixo"
        :rows-per-page-options="[0]"
        dense
        hide-bottom
        color="primary"
      >
      </q-table>
    </div>

    <div v-if="informacoes.length > 0" class="row justify-end q-mt-md">
      <q-btn
        dense
        label="Salvar Informações"
        color="primary"
        icon="save"
        class="btn"
        no-caps
        @click="salvarInformacoes()"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";

export default {
  setup() {
    const unidade = ref({});
    const $q = useQuasar();
    const store = useStore();
    const router = useRouter();

    const informacoes = ref([]);
    const proximoId = ref(1);

    const novaInformacao = ref({
      areaTrabalho: "",
      observacao: "",
      recomendacao: "",
      outrasMedidas: "",
      aviso: "",
    });

    const columns = [
      {
        name: "areaTrabalho",
        required: true,
        label: "Área de Trabalho",
        align: "left",
        field: "areaTrabalho",
        sortable: true,
      },
      {
        name: "observacao",
        label: "Observação",
        align: "left",
        field: "observacao",
        sortable: true,
      },
      {
        name: "outrasMedidas",
        label: "Outras Medidas",
        align: "left",
        field: "outrasMedidas",
        sortable: true,
      },
      {
        name: "aviso",
        label: "Aviso",
        align: "left",
        field: "aviso",
        sortable: true,
      },
      {
        name: "recomendacao",
        label: "Recomendação",
        align: "left",
        field: "recomendacao",
        sortable: true,
      },
    ];

    const adicionarInformacao = () => {
      const temDados = Object.values(novaInformacao.value).some(
        (valor) => valor && valor.toString().trim() !== ""
      );

      if (!temDados) {
        $q.notify({
          message: "Preencha pelo menos um campo para adicionar a informação",
          color: "warning",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
        return;
      }

      informacoes.value.push({
        id: proximoId.value++,
        ...novaInformacao.value,
      });

      novaInformacao.value = {
        areaTrabalho: "",
        observacao: "",
        recomendacao: "",
        outrasMedidas: "",
        aviso: "",
      };

      $q.notify({
        message: "Informação adicionada com sucesso",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {},
          },
        ],
      });
    };

    const salvarInformacoes = async () => {
      try {
        if (!unidade.value?.id) {
          $q.notify({
            message: "Erro: Unidade não identificada. Recarregue a página.",
            color: "negative",
          });
          return;
        }

        if (informacoes.value.length === 0) {
          $q.notify({
            message: "Adicione pelo menos uma informação antes de salvar",
            color: "warning",
          });
          return;
        }

        const dadosParaEnvio = {
          unidadeId: unidade.value.id,
          areaTrabalho: informacoes.value[0]?.areaTrabalho || "",
          observacao: informacoes.value[0]?.observacao || "",
          recomendacao: informacoes.value[0]?.recomendacao || "",
          outrasMedidas: informacoes.value[0]?.outrasMedidas || "",
          aviso: informacoes.value[0]?.aviso || "",
        };

        await store.dispatch(
          "pdt/enviarConfiguraçõesInformacao",
          dadosParaEnvio
        );

        $q.notify({
          message: "Informações salvas com sucesso",
          color: "positive",
        });
      } catch (error) {
        console.error("Erro ao salvar informações:", error);
        $q.notify({
          message: "Erro ao salvar informações",
          color: "negative",
        });
      }
    };

    const receberInformacoes = async () => {
      try {
        if (!unidade.value?.id) return;

        const resposta = await store.dispatch(
          "pdt/receberConfiguraçõesInformacao",
          {
            unidadeId: unidade.value.id,
          }
        );

        if (resposta?.data?.resultado?.dados) {
          const dados = resposta.data.resultado.dados;
          if (Array.isArray(dados)) {
            informacoes.value = dados.map((item, index) => ({
              id: index + 1,
              ...item,
            }));
            proximoId.value = informacoes.value.length + 1;
          } else {
            informacoes.value = [
              {
                id: 1,
                ...dados,
              },
            ];
            proximoId.value = 2;
          }
        }
      } catch (error) {
        console.error("Erro ao carregar informações:", error);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      (newValue) => {
        if (newValue?.id) {
          unidade.value = newValue;
          receberInformacoes();
        }
      },
      { immediate: true }
    );

    const voltar = () => {
      router.push({ name: "pdt-unidade" });
    };

    onMounted(() => {
      if (store.state.org.unidadeData?.id) {
        unidade.value = store.state.org.unidadeData;
        receberInformacoes();
      }
    });

    return {
      unidade,
      informacoes,
      novaInformacao,
      columns,
      adicionarInformacao,
      salvarInformacoes,
      voltar,
    };
  },
};
</script>

<style scoped>
.icon {
  cursor: pointer;
}

.titulo-table {
  font-size: 18px;
}

@media (max-width: 600px) {
  .titulo-input {
    font-size: 12px;
    margin: 0px 0px 0px 0px;
  }
  .input {
    font-size: 10px;
  }
  .btn {
    font-size: 12px;
  }
  .btn-enviar {
    font-size: 12px;
    margin-left: 8px;
  }
  .titulo-table {
    font-size: 14px;
    margin: 30px 0px 18px 8px;
  }
}
</style>
